


class  BWindow {

    constructor() {
        this.isCef = window.hasOwnProperty("cefQuery");

        this.HcloseEv=this.closeEv.bind(this);
        this.HtoggleMaxEv=this.toggleMaxEv.bind(this);
        this.HminimizeEv=this.minimizeEv.bind(this);
    }

    IsMaximize() {
        window.cefQuery({
            request: 'WindowTest.IsMaximize',
            onSuccess: function(response) {
                alert(response);
            },
            onFailure: function(error_code, error_message) {}
        });
    }

    send_message(test, params) {
        var message = 'WindowTest.' + test;
        if (typeof params != 'undefined')
            message += ':' + params;

        // Results in a call to the OnQuery method in window_test.cpp.
        window.cefQuery({'request' : message});
    }

    minimize() {
        this.send_message('Minimize');
    }

    CustomCaptionBar() {
        this.send_message('CustomCaptionBar');
        //this.send_message('Minimize');
        //this.send_message('Restore');
    }

    SystemCaptionBar() {
        this.send_message('SystemCaptionBar');
        //this.send_message('Minimize');
        //this.send_message('Restore');
    }

    maximize() {
        this.send_message('Maximize');
    }

    restore() {
        this.minimize();
        let plugin=this;
        setTimeout(function() { plugin.send_message('Restore'); }, 1000);
    }

    closeWin() {
        window.close();
    }

    closeEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.closeWin();
        return false;
    }

    minimizeEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.minimize();
        return false;
    }

    toggleMaxEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.maximize();
        return false;
    }

}



export default BWindow;

